export default __webpack_public_path__ + "static/media/photo--lg--60.0035e085.jpg";